import { render, staticRenderFns } from "./MediumCar.vue?vue&type=template&id=9bcf3dfa"
import script from "./MediumCar.vue?vue&type=script&lang=js"
export * from "./MediumCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports